import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export const resolveAsset = (url) => (url && url.startsWith("/") ? `${BACKEND_URL}${url}` : url);

export const apiError = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  if (d?.code === "session_revoked") return "You were signed out on this device";
  if (d?.code === "session_expired") return "Your session expired — please sign in again";
  if (d?.detail) return String(d.detail);
  return fallback;
};

api.interceptors.response.use(
  (r) => r,
  (error) => {
    const d = error.response?.data?.detail;
    const onAuthPage = ["/login", "/enter"].some((p) => window.location.pathname.startsWith(p));
    if (error.response?.status === 401 && (d?.code === "session_revoked" || d?.code === "session_expired") && !onAuthPage) {
      window.location.assign(d.code === "session_revoked" ? "/login?reason=transferred" : "/login");
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);
